<template>
  <div name="hrms73e-group">
    <div class="evaluation-header clearfix cursor-pointer border-top-color-skin" @click="toggleGroup()">
      <div class="col-xs-8 clear-padding">
        <div class="col-xs-12 col-md-4 clear-padding">{{ labels['HRMS73E2']['80'] }} {{ dataGroup.numgrup }}</div>
        <div class="col-xs-12 col-md-6 clear-padding evaluation-title">{{ dataGroup.desc_numgrup }}</div>
      </div>
      <div class="col-xs-4 clear-padding evaluation-score">{{ calResultScore(dataGroup) }}/{{ calTotalScore(dataGroup) }}</div>
    </div>
    <div class="evaluation-body" v-show="groupDisp">
      <div class="evaluation-section clearfix">
        <template v-for="(item, index) in dataGroup.numitem">
          <hrms73e-item :dataGroup="dataGroup"
                        :item="item"
                        :choices="choices"
                        :name="name" />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import hrms73eItem from 'components/hrms73e/item'

export default {
  name: 'hrms73e-group',
  data () {
    return {
      groupDisp: false
    }
  },
  props: {
    labels: {
      type: Object
    },
    dataGroup: {
      type: Object,
      required: true
    },
    choices: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      required: true
    }
  },
  methods: {
    toggleGroup () {
      this.groupDisp = !this.groupDisp
    },
    calResultScore (dataGroup) {
      let groupQtyscor = 0
      if (dataGroup.numitem.length > 0) {
        groupQtyscor = dataGroup.numitem.map((item) => {
          return parseFloat(item.qtyscor)
        }).reduce((a, b) => {
          return parseFloat(a) + parseFloat(b)
        })
      }
      this.$set(dataGroup, 'qtyscor', groupQtyscor)
      return groupQtyscor
    },
    calTotalScore (dataGroup) {
      let groupQtyfscor = 0
      if (dataGroup.numitem.length > 0) {
        groupQtyfscor = dataGroup.numitem.map((item) => {
          return parseFloat(item.qtyfscor)
        }).reduce((a, b) => {
          return parseFloat(a) + parseFloat(b)
        })
      }
      this.$set(dataGroup, 'qtyfscor', groupQtyfscor)
      return groupQtyfscor
    }
  },
  components: {
    hrms73eItem
  }
}
</script>


// WEBPACK FOOTER //
// group.vue?23c6414e